import { PromoBanner } from "./PromoBanner";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileCallButton } from "./MobileCallButton";

export const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col min-h-screen">
    <PromoBanner />
    <Header />
    <main className="flex-1 pb-20 lg:pb-0">{children}</main>
    <Footer />
    <MobileCallButton />
  </div>
);
